"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralCreditsSummaryDto = instanceOfReferralCreditsSummaryDto;
exports.ReferralCreditsSummaryDtoFromJSON = ReferralCreditsSummaryDtoFromJSON;
exports.ReferralCreditsSummaryDtoFromJSONTyped = ReferralCreditsSummaryDtoFromJSONTyped;
exports.ReferralCreditsSummaryDtoToJSON = ReferralCreditsSummaryDtoToJSON;
exports.ReferralCreditsSummaryDtoToJSONTyped = ReferralCreditsSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the ReferralCreditsSummaryDto interface.
 */
function instanceOfReferralCreditsSummaryDto(value) {
    if (!('pendingCount' in value) || value['pendingCount'] === undefined)
        return false;
    return true;
}
function ReferralCreditsSummaryDtoFromJSON(json) {
    return ReferralCreditsSummaryDtoFromJSONTyped(json, false);
}
function ReferralCreditsSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pendingCount': json['pendingCount'],
        'activeDaysRemaining': json['activeDaysRemaining'] == null ? undefined : json['activeDaysRemaining'],
    };
}
function ReferralCreditsSummaryDtoToJSON(json) {
    return ReferralCreditsSummaryDtoToJSONTyped(json, false);
}
function ReferralCreditsSummaryDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pendingCount': value['pendingCount'],
        'activeDaysRemaining': value['activeDaysRemaining'],
    };
}
